module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "kp-tab-edit"
  }, [_c('basic-option'), _vm._v(" "), _c('naked-option'), _vm._v(" "), _c('external-option')], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-4d6e5b60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/triggerbutton/options/Main.vue
 ** module id = 822
 ** module chunks = 1
 **/